//  Menu
let menuOpen = false;
const menuTrigger = document.querySelector(".menu__trigger");
const menu = document.querySelector(".mobile__nav");

if (menuTrigger && menu) {
	// Setup menu trigger.
	menuTrigger.addEventListener("click", () => {
		menuOpen = !menuOpen;
		menuTrigger.classList[menuOpen ? "add" : "remove"]("active");
		menu.classList[menuOpen ? "add" : "remove"]("active");

		// Update aria-label
		if (menuTrigger.getAttribute("aria-label") === "Abrir Menu") {
			menuTrigger.setAttribute("aria-label", "Fechar Menu");
		} else {
			menuTrigger.setAttribute("aria-label", "Abrir Menu");
		}
	});

	// Close menu when clicking outside the menu
	document.addEventListener("click", (event) => {
		if (!menu.contains(event.target) && !menuTrigger.contains(event.target)) {
			menuTrigger.classList.remove("active");
			menu.classList.remove("active");
			menuOpen = false;
		}
	});
}

jQuery(function ($) {
	$(".mobile__nav li.hasChildren > a").on("click", function(e){
		e.preventDefault();
		$(this).toggleClass('active').next("ul").toggleClass('opened');
	});
});
